// src/runtime/bootstrap.ts
(() => {
  const PROOF = "[orrekie-bootstrap-proof]";
  const meta = import.meta;
  const dev = meta?.env?.DEV;
  const mode = meta?.env?.MODE;
  const metaUrl = meta?.url ?? "n/a";
  const hasWindow = typeof window !== "undefined";
  const appMarker = hasWindow ? window?.__ORREKIE_APP__ : void 0;
  try {
    console.log(
      `${PROOF} reached execution DEV=${dev} MODE=${String(mode)} hasWindow=${hasWindow} appMarker=${String(appMarker)} import.meta.url=${String(metaUrl)}`
    );
  } catch {
  }
  const inBrowser = hasWindow && typeof document !== "undefined";
  const fromEnv = dev === true || mode === "development";
  const localDevHost = inBrowser && typeof window.location?.hostname === "string" && (() => {
    const h = window.location.hostname.toLowerCase();
    return h === "localhost" || h === "127.0.0.1" || h === "orrekie.local" || h.endsWith(".orrekie.local");
  })();
  const isDev = fromEnv || localDevHost;
  if (!inBrowser || !isDev) return;
  const DIAG_PREFIX = "[orrekie-bootstrap]";
  const targetPath = "/__orrekie/dev/beacon";
  const mirrorPath = "/__orrekie/dev/console-mirror";
  const origin = window.location.origin;
  const targetUrl = origin + targetPath;
  const appName = window?.__ORREKIE_APP__ || "app";
  const mirror = (msg) => {
    console.log(msg);
    fetch(mirrorPath, { method: "POST", headers: { "Content-Type": "text/plain" }, body: msg.slice(0, 500), keepalive: true }).catch(() => {
    });
  };
  try {
    const payload = {
      app: appName,
      ts: Date.now(),
      ready: true,
      email: import.meta?.env?.VITE_ORREKIE_AUTO_EMAIL || "individual_user@orrekie.com"
    };
    mirror(`${DIAG_PREFIX} before beacon POST origin=${origin} target=${targetUrl} app=${appName}`);
    fetch(targetPath, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true
    }).then((res) => {
      mirror(`${DIAG_PREFIX} after beacon POST origin=${origin} target=${targetUrl} app=${appName} ok=${res.ok} status=${res.status}`);
    }).catch((err) => {
      mirror(`${DIAG_PREFIX} after beacon POST (failed) origin=${origin} target=${targetUrl} app=${appName} err=${String(err?.message ?? err)}`);
    });
  } catch (e) {
    mirror(`${DIAG_PREFIX} before beacon threw origin=${origin} target=${targetUrl} app=${appName} err=${String(e?.message ?? e)}`);
  }
})();
